/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
 */

let MainMeetingSchedulePage = () => import(/* webpackChunkName: "scheduler" */ "@/core/modules/scheduler/MainEventSchedulePage.vue");
let CancelMainMeetingSchedulePage = () => import(/* webpackChunkName: "scheduler" */   "@/core/modules/scheduler/CancelMainEventSchedulePage.vue");

let ConfirmedEventPage  = () => import(/* webpackChunkName: "scheduler" */ "@/core/modules/scheduler/ConfirmedEventPage.vue");
import mergeProps from "@/router/utils/mergeProps.js";


export default [
	{
		path: '/cancel/:coachId/:scheduledEventId',
		name: 'CancelMeetingPage',
		component: CancelMainMeetingSchedulePage,
		props: (route) => ({
			...route.query,
			...route.params,
			actionType: "cancel",
		}),
		meta:{
			isWhitelisted: true
		}
	},

	{
		path: '/reschedule/:coachId/:scheduledEventId',
		name: 'RescheduleMeetingPage',
		component: MainMeetingSchedulePage,
		props: (route) => ({
			...route.query,
			...route.params,
			actionType: "reschedule",
		}),
		meta:{
			isWhitelisted: true
		}
	},

	{
		path: '/:eventTypeUserId/:eventTypeId',
		name: 'MainMeetingSchedulePage',
		component: MainMeetingSchedulePage,
		props: (route) => ({
			...route.query,
			...route.params,
			actionType: "schedule",
			clientIdParam: route.query.clientId || route.query.cid,
			paymentStatus: route.query.payment_status,
		}),
		meta:{
			isWhitelisted: true
		}
	},
	{
		path: '/:eventTypeUserId/:eventTypeId/confirmed/:eventId',
		name: 'ConfirmedEventPage',
		component: ConfirmedEventPage,
		props: mergeProps,
		meta:{
			isWhitelisted: true
		}
	}
]
